module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/deutsche_teilkauf_online_advertorial.jpg";